// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"dc9f1128","57":"215a7657","147":"aa232a75","244":"1584aea7","349":"98e7c26f","566":"6569a5b5","654":"d72ea079","785":"2c12d486","797":"b58cde79","846":"10007ce8","872":"9c2e3f05","883":"fe63ed7e","904":"7c83002e"}[chunkId] + ".chunk.js";
};